// eslint-disable-next-line max-params
import GlobalComponents from 'components/global-components';
import store from 'redux/store';
import { setShowUpdateEmailAlert } from 'redux/actions/users';
import { setLhsExpanded } from 'redux/actions/layout';
import {
  setFolderExpandedStatus,
  setHighlightedLessonId,
  setReloadCollectionId,
} from 'redux/actions/collections';
import { LearningCatalogButton } from '../../dashboard/components/learning-catalog-button';
import AskNovoAI from '../../institutions/components/ask-novoai';
import URLS_TO_HIDE_ASK_NOVO_AI from '../../institutions/components/ask-novoai/helpers';

/* @ngInject */
export default function MainGridCtrl(
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $timeout,
  $uibModal,
  $window,
  $element,
  $location,
  AlertMessages,
  AnnouncementsManager,
  ConversationsManager,
  CountdownTimerManager,
  CurrentCourseManager,
  CurrentPermissionsManager,
  CurrentUserManager,
  DiscussionsManager,
  InvitationsAndRequestsManager,
  LecturePageManager,
  LiveSessionResources,
  NotificationsManager,
  OfflineManager,
  PageLevelManager,
  PusherChannels,
  PusherManager,
  RailsRoutes,
  TimelinesManager,
  InstitutionsManager,
  TeamWorkspaceManager,
  TimezonesService,
  _,
  humps,
  moment,
  nvCurrentPage,
  nvUtil,
  $uibModalStack,
  FlyOutPanelManager,
) {
  $scope.GlobalComponents = GlobalComponents;
  $scope.LearningCatalogButton = LearningCatalogButton;
  $scope.AskNovoAI = AskNovoAI;

  const vm = this;

  vm.$state = $state;
  vm.$stateParams = $stateParams;

  const toggleNavTimeoutValue = 10;

  vm.popoverId = '';
  vm.isLhsExpandedMobile = false;
  vm.isRhsExpandedMobile = false;
  vm.isLhsExpandedDesktop = false;
  vm.hasRhs = false;
  vm.rhsTitle = '';
  vm.isTopHeaderExpanded = true;
  vm.isAnnouncementsPopoverOpen = false;
  vm.currentUserManager = CurrentUserManager;
  vm.ConversationsManager = ConversationsManager;
  vm.expandedTopHeaderInView = true;
  vm.railsRoutes = RailsRoutes;
  vm.nvCurrentPage = nvCurrentPage;
  vm.CurrentCourseManager = CurrentCourseManager;
  vm.AlertMessages = AlertMessages;
  vm.OfflineManager = OfflineManager;
  vm.CountdownTimerManager = CountdownTimerManager;
  vm.DiscussionsManager = DiscussionsManager;
  vm.TimelinesManager = TimelinesManager;
  vm.LecturePageManager = LecturePageManager;
  vm.pendoProperties = { };

  vm.isLhsExpanded = isLhsExpanded;
  vm.shouldHideLHS = shouldHideLHS;
  vm.toggleLhsMobile = toggleLhsMobile;
  vm.toggleLhsDesktop = toggleLhsDesktop;

  vm.hideLhsMobile = hideLhsMobile;
  vm.hideLhsDesktop = hideLhsDesktop;

  vm.showRhsMobile = showRhsMobile;
  vm.showRhsDesktop = showRhsDesktop;

  vm.hideRhsMobile = hideRhsMobile;
  vm.hideRhsDesktop = hideRhsDesktop;

  vm.broadcastLhsScroll = broadcastLhsScroll;

  vm.boolFreezeNavStates = false;

  vm.currentInstitutionAdmin = currentInstitutionAdmin;

  vm.getTotalNotificationsCount = getTotalNotificationsCount;

  vm.shouldShowMenteeButton = shouldShowMenteeButton;
  vm.shouldShowMentorButton = shouldShowMentorButton;

  vm.isModalOrFlyoutOpen = isModalOrFlyoutOpen;
  vm.focusMainPanel = focusMainPanel;
  vm.showSearchIconDivider = showSearchIconDivider;

  vm.shouldShowAskNovoAI = shouldShowAskNovoAI;

  // Used by license-dashboard.tsx to hack reloading the current router classes
  vm.getDataClasses = getDataClasses;

  // LHS improvements functionality.
  vm.isOrgAdmin = CurrentPermissionsManager.hasOrgAdminPermissions() || CurrentPermissionsManager.hasCourseManagerPermissions();
  vm.isMentor = CurrentPermissionsManager.hasOrgMentorPermissions();
  vm.isCourseAdmin = CurrentUserManager.isCourseAdminInAtLeastOneCourse();
  vm.isSupervisor = CurrentUserManager.isSupervisor();
  vm.hasShownAlert = {};

  let userCoursePusherChannel;
  const ALT_HOST_UPDATE_EVENT_NAME = 'zoom_alternative_hosts_updated';

  const debounced = _.debounce(() => {
    if (!$scope.$$phase) {
      $scope.$apply();
    }
  }, 100);

  $scope.$on('$destroy', () => {
    if (CurrentUserManager.hasLoggedIn()) {
      PusherManager.channelsHash[PusherChannels.announcementsChannel].unbind('new_announcement', $scope.newAnnouncementEventHandler);
      PusherManager.currentUserChannel().unbind('announcements_read', $scope.announcementsReadEventHandler);
      PusherManager.currentUserChannel().unbind('new_conversation', $scope.newMessageOrConversationEventHandler);
      PusherManager.currentUserChannel().unbind('new_message', $scope.newMessageOrConversationEventHandler);
      PusherManager.currentUserChannel().unbind('live_session_notification_status', $scope.liveSessionEventHandler);
      PusherManager.currentUserChannel().unbind('enrolled_in_course', $scope.enrolledInCourseHandler);
      PusherManager.currentUserChannel().unbind('unenrolled_from_course', $scope.unenrolledInCourseHandler);
      PusherManager.currentUserChannel().unbind('meeting_started', $scope.workspaceMeetingHandler);
      PusherManager.currentUserChannel().unbind('content_management_lecture_section_copied');
      PusherManager.currentUserChannel().unbind('content_management_lecture_page_copied');
      PusherManager.currentUserChannel().unbind('content_management_lecture_section_duplicated');
      PusherManager.currentUserChannel().unbind('content_management_lecture_page_duplicated');

      if (userCoursePusherChannel) {
        userCoursePusherChannel.unbind(ALT_HOST_UPDATE_EVENT_NAME, $scope.invalidAlternativeHostsHandler);
      }
    }
  });

  $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
    if (toState.data.level === 4 || (fromState.data.level === 4 && toState.data.level === 4)) {
      vm.boolFreezeNavStates = true;
    }
  });

  $rootScope.$on('$stateChangeStart', () => {
    if (CurrentUserManager.user.hasSystemGeneratedAddress) {
      store.dispatch(setShowUpdateEmailAlert(true));
    }
  });

  // Custom styles are added to the main-content div by ui-scroll-viewport
  // and it is retained when switching to other pages, which causes other
  // pages to break. So removing the style when switching the routes.
  $rootScope.$on('$stateChangeStart', () => {
    $('#main-content').removeAttr('style');
  });

  $rootScope.$on('$stateChangeSuccess', refetchData);

  angular.element($window).on('resize', debounced);

  $scope.$on('$destroy', () => {
    angular.element($window).off('resize', debounced);
  });

  initialize();

  function initialize() {
    if (nvCurrentPage.unreadPrivacyPolicy()) {
      const button = {
        text: 'LHS.ACCOUNT_MENU.PRIVACY_POLICY.ALERT.LEARN_MORE',
        onClick: () => $uibModal.open({
          templateUrl: 'shared/templates/privacy-policy-modal.html',
          controller: 'PrivacyPolicyModalCtrl as vm',
          resolve: {
            currentInstitution: nvCurrentPage.getInstitution(),
          },
        }),
      };
      const onClose = () => nvCurrentPage.markUnreadPrivacyPolicyAsRead();
      AlertMessages.info('LHS.ACCOUNT_MENU.PRIVACY_POLICY.ALERT.NOTE', 'LHS.ACCOUNT_MENU.PRIVACY_POLICY.ALERT.PRIVACY_UPDATED', {}, {}, Infinity, button, onClose);
    }
    if (nvCurrentPage.unreadCookiePolicy()) {
      const onClose = () => nvCurrentPage.markUnreadCookiePolicyAsRead();
      AlertMessages.info('LHS.ACCOUNT_MENU.PRIVACY_POLICY.ALERT.NOTE', 'LHS.ACCOUNT_MENU.PRIVACY_POLICY.ALERT.COOKIES_1', {}, {
        privacyLink: ' https://www.novoed.com/privacy-policy/',
        cookieLink: 'https://www.novoed.com/novoed-cookie-policy/',
        tosLink: 'https://www.novoed.com/terms-of-service/',
      }, Infinity, null, onClose);
    }
    if (CurrentUserManager.hasLoggedIn()) {
      Promise.all([
        CurrentUserManager.requestUserConfigPromise ?? Promise.resolve(),
        CurrentUserManager.requestAccountEnrollmentsPromise ?? Promise.resolve(),
      ]).then(() => {
        PusherManager.setupChannel(PusherChannels.announcementsChannel).bind('new_announcement', newAnnouncementEventHandler);
        PusherManager.currentUserChannel().bind('announcements_read', announcementsReadEventHandler);
        PusherManager.currentUserChannel().bind('new_conversation', newMessageOrConversationEventHandler);
        PusherManager.currentUserChannel().bind('new_message', newMessageOrConversationEventHandler);
        PusherManager.currentUserChannel().bind('live_session_notification_status', liveSessionEventHandler);
        PusherManager.currentUserChannel().bind('enrolled_in_course', enrolledInCourseHandler);
        PusherManager.currentUserChannel().bind('unenrolled_from_course', unenrolledInCourseHandler);
        PusherManager.currentUserChannel().bind('meeting_started', workspaceMeetingHandler);
        PusherManager.currentUserChannel().bind('content_management_lecture_section_copied', (data) => copyDuplicateHandler(data, 'copy_folder'));
        PusherManager.currentUserChannel().bind('content_management_lecture_page_copied', (data) => copyDuplicateHandler(data, 'copy_lesson'));
        PusherManager.currentUserChannel().bind('content_management_lecture_section_duplicated', (data) => copyDuplicateHandler(data, 'duplicate_folder'));
        PusherManager.currentUserChannel().bind('content_management_lecture_page_duplicated', (data) => copyDuplicateHandler(data, 'duplicate_lesson'));
      });

      // Update User Database
      const timezone = TimezonesService.correctSpelling(moment.tz.guess());
      if (timezone && CurrentUserManager.user.browserTimeZone !== timezone) {
        CurrentUserManager.user.updateAutomaticBrowserTimezone(timezone);
      }

      if (CurrentCourseManager.course?.id && CurrentUserManager.isAdmin()) {
        userCoursePusherChannel = PusherManager.setupChannel(
          PusherChannels.userCourseChannel(
            CurrentUserManager.user.anonymizedIdentifier.substr(0, 10),
            CurrentCourseManager.course.id,
          ),
        );
        userCoursePusherChannel.bind(ALT_HOST_UPDATE_EVENT_NAME, invalidAlternativeHostsHandler);
      }
    }
    // set initial state for LHS
    refetchData();
  }

  function getDataClasses() {
    vm.dataClasses = nvCurrentPage.getNonL4Data() || {};

    if (nvCurrentPage.getNonL4Data() && nvCurrentPage.getNonL4Data().headerClass) {
      vm.dataClasses.headerClass = nvCurrentPage.getNonL4Data().headerClass;
    } else {
      vm.dataClasses.headerClass = 'default';
    }

    if (nvCurrentPage.getNonL4Data() && nvCurrentPage.getNonL4Data().mainClass) {
      vm.dataClasses.mainClass = nvCurrentPage.getNonL4Data().mainClass;
    } else {
      vm.dataClasses.mainClass = '';
    }

    if (nvCurrentPage.getNonL4Data() && nvCurrentPage.getNonL4Data().mainPanelClass) {
      vm.dataClasses.mainPanelClass = nvCurrentPage.getNonL4Data().mainPanelClass;
    } else {
      vm.dataClasses.mainPanelClass = '';
    }


    vm.dataClasses.scrollable = nvCurrentPage.getNonL4Data() && nvCurrentPage.getNonL4Data().mainPanelScrollable;

    vm.hasRhs = nvCurrentPage.getNonL4Data() && CurrentCourseManager.course
        && (($state.is('course-home') || $state.is('course-home-edit') || $state.is('program-home'))
          ? CurrentCourseManager.course.showCommunityPanel : true) ? nvCurrentPage.getNonL4Data().hasRhs : false;
    vm.rhsTitle = nvCurrentPage.getNonL4Data() ? nvCurrentPage.getNonL4Data().rhsTitle : '';

    // Programatically checks whether we are in the edit or restricted edit mode to add the appropriate
    // CSS class required by some of our angularjs components
    if ($state.current.parent === 'lecture-page-parent') {
      if (
        ($state.params.rest?.startsWith('edit') || $state.params.rest?.startsWith('restrictedEdit'))
        && !vm.dataClasses.mainClass.includes('lecture-page-edit')
      ) {
        vm.dataClasses.mainClass += ' lecture-page-edit';
      }
      if (!$state.params.rest && !vm.dataClasses.mainClass.includes('lecture-page-view')) {
        // Means this is view mode
        vm.dataClasses.mainClass += ' lecture-page-view';
      }
    }
  }

  function setInitialLhsState() {
    if (nvCurrentPage.getPageLevel() < 4 && !vm.boolFreezeNavStates) {
      // vm.isLhsExpandedDesktop = false; // remembering user's latest state; as opposed to overwriting
      vm.isLhsExpandedMobile = false; // closing mobile on state change regardless of user action since it is an overlay on mobile
    } else if (vm.boolFreezeNavStates) {
      vm.boolFreezeNavStates = false;
    }
    // adding new behavior: expanded LHS based on data.expandedLHS property on routes.js
    // as data properties are inherited, we need to check if the data object has its own expandedLHS property.
    vm.isLhsExpandedDesktop = Object.prototype.hasOwnProperty.call($state.current.data, 'expandedLHS');
    // trigger an update of the body class.
    vm.toggleLhsDesktop();
  }

  function setInitialRhsState() {
    if (nvCurrentPage.getPageLevel() < 4 && !vm.boolFreezeNavStates) {
      vm.isRhsExpandedMobile = false; // closing mobile on state change regardless of user action since it is an overlay on mobile
    }
  }

  function getLiveEvents() {
    LiveSessionResources.activeFlashNotifications()
      .$promise.then((response) => {
        response.result.forEach((note) => liveSessionEventHandler(note));
      });
  }

  function getTeamMeetings() {
    if (CurrentCourseManager?.course?.catalogId) {
      CurrentUserManager.currentUserCourse?.getUserCourseMeetings().then(meetings => {
        _.map(meetings, (meeting) => {
          const minutesLeft = moment(meeting.startTime).diff(moment(), 'minutes');
          if (minutesLeft <= 1) {
            workspaceMeetingHandler(meeting, false);
          }
        });
      });
    }
  }

  function refetchData() {
    setInitialLhsState();
    setInitialRhsState();
    getDataClasses();
    getLiveEvents();
    setPendoProperties();
    getTeamMeetings();
  }

  function setPendoProperties() {
    const currentCourse = CurrentUserManager.coursesHashByCatalogId[$state.params.catalogId];
    if (!currentCourse) {
      vm.pendoProperties = {};
    } else {
      vm.pendoProperties = _.extend(
        currentCourse.getPendoProperties(),
        CurrentPermissionsManager.getPendoProperties(),
      );
    }
  }

  function shouldHideLHS() {
    return (
      $state.is('learning-journey-basics')
      && !CurrentPermissionsManager.hasCourseManagerPermissions()
    );
  }

  function isLhsExpanded() {
    return vm.isLhsExpandedMobile || vm.isLhsExpandedDesktop;
  }

  // yes I know these functions break the DRY principle but it's what happens when Design wants non-responsive forking behavior
  function toggleLhsMobile() {
    // give opening and closing LHS a nontrivial timeout so the popovers can close first and not look funny
    $timeout(() => {
      vm.isLhsExpandedMobile = !vm.isLhsExpandedMobile;

      // Update a class for body, so that elements like flyout can understand
      // whether lhs is expanded or not
      if (vm.isLhsExpandedMobile) {
        angular.element('body').addClass('mobile-lhs-expanded');
      } else {
        angular.element('body').removeClass('mobile-lhs-expanded');
      }
      // vm.isLhsExpandedDesktop = vm.isLhsExpandedMobile;

      // Set focus to inside of the LHS panel with a timout to have the component ready
      setTimeout(() => {
        let parentElement = $element.find('#mobile-left-nav')?.[0];
        // In case it's closing, it focuses on the menu icon
        if (!vm.isLhsExpandedMobile) {
          parentElement = $element.find('#top-nav')?.[0];
        }
        if (parentElement) {
          nvUtil.focusFirstElement(parentElement);
        }
      }, toggleNavTimeoutValue);
    }, toggleNavTimeoutValue);
  }

  function toggleLhsDesktop() {
    // give opening and closing LHS a nontrivial timeout so the popovers can close first and not look funny
    $timeout(() => {
      // Update a class for body, so that elements like flyout can understand
      // whether lhs is expanded or not
      if (vm.isLhsExpandedDesktop) {
        angular.element('body').addClass('desktop-lhs-expanded');
      } else {
        angular.element('body').removeClass('desktop-lhs-expanded');
      }
      // vm.isLhsExpandedMobile = vm.isLhsExpandedDesktop;
    }, toggleNavTimeoutValue);
  }

  function hideLhsMobile() {
    $timeout(() => {
      vm.isLhsExpandedMobile = false;
    }, toggleNavTimeoutValue);
  }

  function hideLhsDesktop() {
    $timeout(() => {
      vm.isLhsExpandedDesktop = false;
    }, toggleNavTimeoutValue);
  }

  function showRhsMobile() {
    // give opening and closing RHS a nontrivial timeout so the popovers can close first and not look funny
    $timeout(() => {
      vm.isRhsExpandedMobile = true;
    }, toggleNavTimeoutValue);
  }

  function showRhsDesktop() {
    // give opening and closing RHS a nontrivial timeout so the popovers can close first and not look funny
    $timeout(() => {
      vm.isRhsExpandedDesktop = true;
    }, toggleNavTimeoutValue);
  }

  function hideRhsMobile() {
    // give opening and closing RHS a nontrivial timeout so the popovers can close first and not look funny
    $timeout(() => {
      vm.isRhsExpandedMobile = false;
    }, toggleNavTimeoutValue);
  }

  function hideRhsDesktop() {
    // give opening and closing RHS a nontrivial timeout so the popovers can close first and not look funny
    $timeout(() => {
      vm.isRhsExpandedDesktop = false;
    }, toggleNavTimeoutValue);
  }

  function showSearchIconDivider() {
    /**
     * Always show the LHS section divider below the search icon in not expanded view
     * In expanded view if there is courses then 'Courses' heading will show instead of the divider.
     * If it is in institution dashboard, 'Admin Controls' heading will show instead of the divider.
     */
    return (!vm.isLhsExpandedDesktop
      || (vm.isLhsExpandedDesktop
          && vm.currentUserManager.courses.length === 0
          && vm.$state.current.name !== 'institution-dashboard'));
  }

  function broadcastLhsScroll() {
    $scope.$broadcast('lhsScroll');
  }

  function currentInstitutionAdmin() {
    const institution = nvCurrentPage.getCurrentWalledGardenInstitution();
    let institutionId;

    if (institution?.isInstitutionalAdmin) {
      return institution;
    }

    const reduxState = store.getState();
    if (reduxState?.app?.currentInstitutionId) {
      institutionId = reduxState.app.currentInstitutionId;
    } else if ($state.params.catalogId && InstitutionsManager?.institution) {
      institutionId = InstitutionsManager.institution.id;
    } else {
      ({ institutionId } = $state.params);
    }
    return CurrentUserManager.getInstitutionAdmin(institutionId);
  }

  /**
   * Controls the visibility of the AskNovoAI component.
   * Returns true if AskNovoAI should be shown, false otherwise.
   */
  function shouldShowAskNovoAI() {
    // Check if the current URL is in the list of URLs to hide AskNovoAI
    if (URLS_TO_HIDE_ASK_NOVO_AI.some(url => $location.path().includes(url))) {
      return false;
    }
    // Check if there is a modal-content-mask in the DOM
    if (document.querySelector('.modal-content-mask')) {
      return false;
    }

    // Hide if no course or if in lecture page edit mode
    return !!(CurrentCourseManager.course) && !vm.LecturePageManager.isEditMode();
  }

  // Private Functions
  function enrolledInCourseHandler(pusherData) {
    pusherData = humps.camelizeKeys(pusherData);

    CurrentUserManager.refreshUserCourse(pusherData.course.id);
  }

  function unenrolledInCourseHandler(pusherData) {
    CurrentUserManager.removeCourse(pusherData.course);
  }

  function newAnnouncementEventHandler(pusherData) {
    pusherData = humps.camelizeKeys(pusherData);
    AnnouncementsManager.newAnnouncement(pusherData.id, pusherData.courseId);
  }

  function announcementsReadEventHandler(data) {
    // we don't care about read notifications. would be done by the same user in another session
  }

  function newMessageOrConversationEventHandler() {
    ConversationsManager.initialize();
  }

  function getTotalNotificationsCount() {
    return CurrentCourseManager.course
      && AnnouncementsManager.numUnreadAnnouncements
      + NotificationsManager.numUnreadNotifications
      + InvitationsAndRequestsManager.numItems
      + ConversationsManager.numUnreadMessages;
  }

  // show this button only for L1 pages, we will special case L2s and L3s with sticky footers
  // Shows the button for viewing the list of assigned mentees
  // TODO: This needs updated for the new architecture
  function shouldShowMenteeButton() {
    return !$state.includes('mentees')
        && ($state.includes('course') || $state.params.catalogId)
        && (
          ($state.current.data.level === 3.5 ? (FlyOutPanelManager.lastNonFlyoutState.state.includes.course !== undefined) : (
            nvCurrentPage.getPageLevel() === 1
            || nvCurrentPage.getPageLevel() === 2
            || (nvCurrentPage.getCurrentStateData().level === 4 && PageLevelManager.lastParent().state.data.level === 1 && PageLevelManager.lastParent().state.name !== 'mentees')
          ))
        )
        && vm.CurrentCourseManager.course
        && CurrentPermissionsManager.isMentor()
        // No need to display the MenteeButton in edit modes
        && !(vm.TimelinesManager.isEditMode() || vm.TimelinesManager.isReorderMode()
          || vm.LecturePageManager.isEditMode() || vm.LecturePageManager.isRestrictedEditMode() || vm.LecturePageManager.isReorderMode())
        // No need to show in journey home. ref: NOV-93109
        && !nvCurrentPage.isJourneyHome();
  }

  // Shows the button for viewing the list of this user's mentors
  function shouldShowMentorButton() {
    return ($state.is('course-home') || $state.is('program-home')) && CurrentCourseManager.course?.userCourse?.mentors?.length;
  }

  // Live Sessions Notifications
  function liveSessionEventHandler(pusherDataSnaked) {
    const {
      joinUrl, catalogId, liveSessionId, eventName, lecturePageId, isRegistered,
      isMultisessionEnabled, lectureComponentId, isRegistrationEnabled, endTime,
      registrationLimit, totalRegisteredUsersCount,
    } = humps.camelizeKeys(pusherDataSnaked);

    let requestedJoin = false;
    const duration = moment(endTime) - moment();
    let button;
    let notificationtext;
    const hasReachedLimit = registrationLimit != null && (registrationLimit === 0 || totalRegisteredUsersCount >= registrationLimit);


    /** show the LE join now banner for:
     * 1. if the learner registered
     * 2. if user is admin
     * 3. if single session
     * 4. if the LE created with old scope (before registration feature)
     */
    const isMultiSessionWithRegistration = isRegistrationEnabled && isMultisessionEnabled;
    const showJoinBanner = (isRegistered || CurrentUserManager.isAdmin()) || !isMultiSessionWithRegistration;

    if (showJoinBanner) {
      notificationtext = 'LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.HAS_STARTED';
      button = {
        text: 'LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.JOIN',
        href: joinUrl,
        target: '_blank',
        onClick: () => {
          requestedJoin = true;
          LiveSessionResources.recordJoinIntention({ catalogId, liveSessionId }, {});
        },
      };
    } else {
      notificationtext = 'LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.NOTIFICATION';
      button = {
        text: 'LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.NOTIFICATION_CTA',
        href: $state.href('lecture-page', {
          catalogId,
          id: lecturePageId,
          lectureActivityId: lectureComponentId,
        }),
        target: '_blank',
      };
    }

    const onClose = () => {
      if (!requestedJoin) {
        LiveSessionResources.dismissNotification({ catalogId, liveSessionId }, {});
      }
    };
    const courseName = CurrentUserManager.courses.find((course) => course.catalogId === catalogId).name;
    if (showJoinBanner || !hasReachedLimit) {
      AlertMessages.liveEvent('', notificationtext, {}, { eventName, courseName }, duration, button, onClose, `liveEvent-${liveSessionId}`);
    }
  }

  function workspaceMeetingHandler(meetingData, isSnaked = true) {
    TeamWorkspaceManager.meetingNotificationHandler(isSnaked ? humps.camelizeKeys(meetingData) : meetingData);
  }

  // Pusher handler to handle copy/duplicate folder or copy lesson of lesson library
  function copyDuplicateHandler(pusherData, transferType) {
    pusherData = humps.camelizeKeys(pusherData);
    const {
      destinationCollectionId,
      destinationCatalogId,
      destinationFolderId,
      createdLessonId,
      title,
    } = pusherData;

    let alertId;
    let message;
    let params = {};
    const stateParams = {
      collectionId: destinationCollectionId,
      catalogId: destinationCatalogId,
      folderId: destinationFolderId,
      lessonId: createdLessonId,
    };
    const redirectToDestination = () => {
      window.open($state?.href(
        'content-library-collection-home',
        stateParams,
      ), '_blank');
    };

    let button = {
      text: 'INSTITUTIONS.CONTENT_LIBRARY.COLLECTIONS_HOME.GO_TO_COLLECTION',
      onClick: redirectToDestination,
    };

    switch (transferType) {
      case 'copy_lesson':
        params = {
          lessonTitle: title,
        };
        message = 'INSTITUTIONS.CONTENT_LIBRARY.COLLECTIONS_HOME.COPY_LESSON_SUCCESS_MSG';
        alertId = `copy-lesson-${createdLessonId}`;
        break;
      case 'copy_folder':
        params = {
          folderTitle: title,
        };
        message = 'INSTITUTIONS.CONTENT_LIBRARY.COLLECTIONS_HOME.COPY_FOLDER_SUCCESS_MSG';
        alertId = `copy-folder-${destinationFolderId}`;
        break;
      case 'duplicate_folder':
        params = {
          title,
        };
        // If user is already in the destination collection, we don't need to show the button to go to the collection
        if ($state.is('content-library-collection-home') && $state.params.collectionId === destinationCollectionId) {
          button = {};
        }
        message = 'INSTITUTIONS.CONTENT_LIBRARY.COLLECTIONS_HOME.DUPLICATE_SUCCESS_MSG';
        alertId = `duplicate-folder-${destinationFolderId}`;
        store.dispatch(setReloadCollectionId(destinationCollectionId));
        break;
      case 'duplicate_lesson':
      {
        store.dispatch(setFolderExpandedStatus({
          folderId: destinationFolderId,
          value: false,
        }));

        const isLecturePageEdit = $state.is('lecture-page-slash') && $state.params.rest?.startsWith('edit');

        // redirect to the newly created lesson page if user is already in the destination collection
        if (($state.is('lecture-page') || isLecturePageEdit)
            && destinationCatalogId === $state?.params?.catalogId) {
          if (isLecturePageEdit) {
            $state.go('lecture-page-edit', { catalogId: destinationCatalogId, id: createdLessonId });
          } else {
            $state.go('lecture-page', { catalogId: destinationCatalogId, id: createdLessonId });
          }
        }

        store.dispatch(setHighlightedLessonId(createdLessonId));
        params = {
          title,
        };
        message = 'INSTITUTIONS.CONTENT_LIBRARY.COLLECTIONS_HOME.DUPLICATE_SUCCESS_MSG';
        alertId = `duplicate-lesson-${createdLessonId}`;
        button = {};
        break;
      }
      default:
    }

    AlertMessages.success('', message, {}, params, 10000, button, () => {}, alertId);
  }

  function invalidAlternativeHostsHandler(pusherDataSnaked) {
    const pusherData = humps.camelizeKeys(pusherDataSnaked);
    if (pusherData?.invalidAlternativeHosts?.length > 0) {
      const invalidEmails = pusherData.invalidAlternativeHosts ?? [];
      const count = invalidEmails.length;
      let emails = '';
      let secondEmail = '';
      let extraCount = 0;

      if (count === 1) {
        emails = invalidEmails[0];
      } else if (count === 2) {
        emails = invalidEmails[0];
        secondEmail = invalidEmails[1];
      } else if (count > 2) {
        emails = invalidEmails.slice(0, 2).join(', ');
        extraCount = count - 2;
      }
      AlertMessages.oAuthError(
        'FORM.OOPS',
        'LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.MODAL.ZOOM_HOST_ERROR.USER_LEVEL',
        {},
        { count, emails, extraCount, secondEmail },
      );
    }
  }

  /**
   * Check whether current state is flyout or modal.
   * Used for adding area-hidden attribute to prevent screen readers
   * reading the main panel when flyout or modal opened
   * @returns boolian
   */
  function isModalOrFlyoutOpen() {
    return $state.includes('modal-page') || $state.includes('flyout-panel') || $uibModalStack.getTop();
  }

  /**
   * Function that find the first focusable element in the main
   * content and focus it when keyboard only use click
   * Skip to content button
   */
  function focusMainPanel() {
    let mainContentId = '#main-panel';
    if ($state.includes('lecture-page')) {
      mainContentId = '#lecture-page-main-content';
    } else if ($state.includes('course-home')) {
      mainContentId = '#main-content';
    }
    const parentElement = $element.find(mainContentId)?.[0];
    if (parentElement) {
      nvUtil.focusFirstElement(parentElement);
    }
  }

  function checkZoomAuthStatusAndShowMessage() {
    const showWarningMessage = (message, params, button, alertId) => {
      AlertMessages.oAuthError('', message, {}, params, Infinity, button, () => {}, alertId);
    };
    let button = {
      text: 'INSTITUTIONS.ADVANCED_SETTINGS.ZOOM_INVALID.BUTTON',
      href: '',
    };

    const handleCourseLevelReauth = () => {
      if (CurrentPermissionsManager.isCourseBuilder() || CurrentPermissionsManager.isInstructor()) {
        CurrentUserManager?.currentUserCourse?.getLiveSessionSettings().then((response) => {
          vm.integrationSettings = response;
          vm.isZoomNeedsReAuthentication = response.ZoomLiveSession?.needsReAuthentication;
          if (vm.isZoomNeedsReAuthentication) {
            if (response.ZoomLiveSession?.source === 'zoomOauth') {
              const refererUrl = `${$location.protocol()}://${$location.host()}/#!${$location.path()}${$location.hash()}`;
              if (vm.integrationSettings.ZoomLiveSession?.authenticatedUser?.id === CurrentUserManager.user?.id
                && vm.integrationSettings.ZoomLiveSession?.createdLiveSessions?.hasCreatedLiveSessions
              ) {
                button.href = RailsRoutes.zoomOAuthInstallationUrl(
                  CurrentCourseManager?.course?.catalogId,
                  '',
                  vm.integrationSettings.ZoomLiveSession?.createdLiveSessions?.redirectLiveSessionUrl ?? refererUrl,
                );
                showWarningMessage(
                  'INSTITUTIONS.ADVANCED_SETTINGS.ZOOM_INVALID.OAUTH_MESSAGE',
                  { user: `${vm.integrationSettings?.ZoomLiveSession?.authenticatedUser?.firstName} ${vm.integrationSettings?.ZoomLiveSession?.authenticatedUser?.lastName}` },
                  button,
                  'zoom-user-level-reauth',
                );
              }
            } else if (!InstitutionsManager.institution?.liveSessionSettings && response.ZoomLiveSession?.source === 'zoomAccountOauth'
              && CurrentPermissionsManager.hasCourseAdminPermissions()
            ) {
              if (vm.integrationSettings.ZoomLiveSession?.authenticatedUser?.id === CurrentUserManager.user?.id) {
                button.href = RailsRoutes.accountZoomOauthUrl(InstitutionsManager.institution?.id);
              } else {
                button = {};
              }

              showWarningMessage(
                'INSTITUTIONS.ADVANCED_SETTINGS.ZOOM_INVALID.ACCOUNT_OAUTH_MESSSAGE',
                { email: vm.integrationSettings.ZoomLiveSession?.authenticatedUser?.accountEmail },
                button,
                'zoom-account-level-reauth',
              );
            }
          }
        });
      }
    };

    const handleInstitutionLevelReAuth = () => {
      if (
        !CurrentPermissionsManager.hasCourseAdminPermissions()
        && !CurrentPermissionsManager.hasMentoringProgramPermissions()
      ) return;

      InstitutionsManager.getLiveSessionSettings().then((liveSessionSettings) => {
        if (CurrentPermissionsManager.hasCourseAdminPermissions()) {
          if (liveSessionSettings?.zoomAccountOauth?.authenticatedStatus === 'not_authenticated') {
            if (liveSessionSettings?.zoomAccountOauth?.authenticatedUser?.id === CurrentUserManager.user?.id) {
              button.href = RailsRoutes.accountZoomOauthUrl(InstitutionsManager.institution?.id);
            } else {
              button = {};
            }

            showWarningMessage(
              'INSTITUTIONS.ADVANCED_SETTINGS.ZOOM_INVALID.ACCOUNT_OAUTH_MESSSAGE',
              { email: liveSessionSettings?.zoomAccountOauth?.authenticatedUser?.accountEmail },
              button,
              'zoom-account-level-reauth',
            );
          }
        }
      });
      if (CurrentPermissionsManager.hasMentoringProgramPermissions()) {
        localStorage.setItem('expiredMessageDisplayedZoom', false);
        localStorage.setItem('expiredMessageDisplayedMsTeams', false);
      }
    };

    if (CurrentCourseManager?.course?.catalogId) {
      handleCourseLevelReauth();
    } else {
      handleInstitutionLevelReAuth();
    }
  }

  async function checkMSCalendaAuthStatusAndShowMessage() {
    if (!vm.isOrgAdmin && !vm.isCourseAdmin) return;

    let institutionMSCalendarSettings;
    try {
      institutionMSCalendarSettings = await InstitutionsManager.getMSCalendarSettings();
    } catch (error) {
      return;
    }

    if (institutionMSCalendarSettings.microsoftGraphCalendarOauth?.authenticatedStatus === 'not_authenticated') {
      AlertMessages.error(
        '',
        'LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.AUTHENTICATION_ERROR.TEAMS_AUTHENTICATE_ERROR',
        {},
        { accountEmail: institutionMSCalendarSettings.microsoftGraphCalendarOauth?.authenticatedUser?.accountEmail },
        Infinity,
        {
          text: 'LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.AUTHENTICATION_ERROR.AUTHENTICATE',
          href: RailsRoutes.authenticateMicrosoftCalendarOauthUrl(InstitutionsManager.institution.id),
        },
        () => {},
        'calendar-auth-error',
      );
    }
  }

  checkZoomAuthStatusAndShowMessage();
  checkMSCalendaAuthStatusAndShowMessage();


  if (CurrentUserManager.user.i18nFteLang) {
    const modalInstance = $uibModal.open({
      templateUrl: 'shared/templates/i18n-modal.html',
      windowClass: 'points-modal mobile-non-blocking super-modal',
      openedClass: 'super-modal',
      controller: 'AttachModalResolvesToVmCtrl as vm',
      keyboard: false,
      resolve: {
        vmResolves() {
          return {
            langKey: CurrentUserManager.user.i18nFteLang,
          };
        },
      },
    });

    modalInstance.closed.then(() => {
      CurrentUserManager.user.updateHasViewedI18nFte();
    });
  }

  $scope.$on('setPopoverId', (event, popoverId) => {
    if (event.targetScope.popoverVm.showPopover) {
      vm.popoverId = popoverId;
    } else if (vm.popoverId === event.targetScope.popoverVm.popoverId) {
      vm.popoverId = popoverId;
    }
  });

  $scope.$watchCollection(
    () => [vm.isLhsExpandedMobile, vm.isLhsExpandedDesktop],
    (newValue) => {
      store.dispatch(setLhsExpanded({
        isLhsExpandedMobile: newValue[0],
        isLhsExpandedDesktop: newValue[1],
      }));
    },
  );
}
